import React from "react";

function VectorUpIcon() {
  return (
    <svg
      width="25"
      height="15"
      viewBox="0 0 25 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.25 1.25L13.75 10.75L8.75 5.75L1.25 13.25M23.25 7.25V1.25H17.25"
        stroke="#B7BCC6"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default VectorUpIcon;
